export default {
    name: 'profileservice',
    dependencies: [
        'xhrservice',
        'objectstore',
        'userservice',
        'imageuploadservice',
        'trackingservice',
        'loginservice',
    ],
    // eslint-disable-next-line max-params
    callable(
        xhr,
        objectstore,
        userservice,
        imageuploadservice,
        trackingService,
        loginService
    ) {
        const cacheKey = 'profile_data';
        const cacheTimeInSeconds = 3600;
        const url = '/user/profile/profileData.json';
        const imageUploadKey = 'profilbilde';

        function getProfileData() {
            const loggedIn = loginService.isLoggedIn();

            if (!loggedIn) {
                return Promise.reject(Error('Not logged in'));
            }

            const profileData = objectstore.get(cacheKey);

            if (profileData) {
                return Promise.resolve(profileData);
            } else {
                return xhr.getJson(url).then(data => {
                    objectstore.put(cacheKey, data, cacheTimeInSeconds);
                    return data;
                });
            }
        }

        function getImagePath() {
            objectstore.del(cacheKey); // Delete cached object to get a fresh one

            return getProfileData().then(profileData => profileData.imagePath);
        }

        function changeProfileImage(newFile) {
            let existingImagePath;
            let userId;
            let uploadedImagePath;
            return getImagePath()
                .then(res => {
                    existingImagePath = res;

                    return userservice.getAccountData();
                })
                .then(accountData => {
                    userId = accountData.userInfo.userId;

                    return imageuploadservice.uploadImage(
                        imageUploadKey,
                        userId,
                        newFile
                    );
                })
                .then(res => {
                    uploadedImagePath = res;

                    return getProfileData();
                })
                .then(profileData => {
                    if (profileData.placeholderImage === true) {
                        trackingService.trackEvent(
                            'administrate.upload-profile-image.click',
                            'success',
                            ''
                        );
                    } else {
                        trackingService.trackEvent(
                            'administrate.change-profile-image.click',
                            'success',
                            ''
                        );
                    }

                    if (existingImagePath) {
                        imageuploadservice.removeImage(
                            imageUploadKey,
                            userId,
                            existingImagePath
                        );
                    }

                    return postProfileImage(uploadedImagePath);
                });
        }

        function removeProfileImage() {
            let imagePath;
            let userId;
            return getImagePath()
                .then(res => {
                    imagePath = res;
                    return userservice.getAccountData();
                })
                .then(accountData => {
                    userId = accountData.userInfo.userId;

                    return imageuploadservice.removeImage(
                        imageUploadKey,
                        userId,
                        imagePath
                    );
                })
                .then(() => {
                    trackingService.trackEvent(
                        'administrate.delete-profile-image.click',
                        'success',
                        ''
                    );

                    return deleteProfileImage();
                });
        }

        function changeDescription(text) {
            trackingService.trackEvent(
                'administrate.update-profile-description.click',
                'success',
                ''
            );

            return postDescription(text);
        }

        function postProfileImage(path) {
            return xhr
                .request({
                    url: '/user/profile/profilePicture.json',
                    data: `profilePicturePath=${path}`,
                    method: 'POST',
                    type: 'json',
                    contentType: 'application/x-www-form-urlencoded',
                })
                .then(() => {
                    objectstore.del(cacheKey);

                    return getProfileData();
                });
        }

        function postDescription(description) {
            return xhr
                .request({
                    url: '/user/profile/profileDescription.json',
                    data: { description },
                    method: 'POST',
                    type: 'json',
                })
                .then(() => {
                    objectstore.del(cacheKey);

                    return getProfileData();
                });
        }

        function deleteProfileImage() {
            return xhr
                .request({
                    url: '/user/profile/profilePicture.json',
                    method: 'DELETE',
                    type: 'json',
                    contentType: 'application/x-www-form-urlencoded',
                })
                .then(() => {
                    objectstore.del(cacheKey);

                    return getProfileData();
                });
        }

        const exports = {
            getProfileData,
            changeProfileImage,
            removeProfileImage,
            changeDescription,
        };

        return exports;
    },
};



// WEBPACK FOOTER //
// ./services/profileservice.js